import { useTranslation } from 'react-i18next';
import { launchReservationGate } from '@/shared/utils/launch-reservation-gate';

/**
 * Persistent notice when the launch is not open and holds are blocked.
 *
 * @param props.status - Current launch lifecycle status
 * @returns Status banner, or null when reservations are allowed
 */
export function LaunchReservationNotice({ status }: { status: string | undefined }) {
  const { t } = useTranslation('features/launches');
  const gate = launchReservationGate(status);
  if (!status || gate.allowed) return null;
  const box = [
    'mt-[var(--space-3)] rounded-(--radius-lg)',
    'border border-[var(--launch-warning-border)] bg-[var(--launch-warning-bg)]',
    'p-[var(--space-3)] text-[length:var(--text-small)] text-[var(--launch-warning-fg)]',
    'shadow-[var(--shadow-sm)]',
  ].join(' ');
  return (
    <div role="status" data-testid="launch-reservation-notice" className={box}>
      {t(`board.reservationBlocked.${gate.reason}`)}
    </div>
  );
}
